<template>
  <div class="full-width">
    <top-nav :isWhite="false" :hasLogo="true" :lang="$route.params.lang"></top-nav>
    <main class="flex flex-column">
      <article class="flex flex-wrap justify-between">
        <header class="px3 py4 col-12">
          <div class="lg-col-9">
            <h1 class="m0" v-if="content.title" v-html="content.title"></h1>
            <p class="m0 h3 mt3" v-if="content.lede" v-html="content.lede"></p>
            <social-sharing
              :url="windowLocation"
              :title="content.title"
              :description="convertHTMLToText(content.lede)"
              hashtags="stop_e40"
              inline-template
            >
              <div class="mt2">
                <network network="twitter">
                  <i class="fa fa-fw fa-twitter social-btn on-light"></i>
                </network>
                <network network="facebook">
                  <i class="fa fa-fw fa-facebook social-btn on-light"></i>
                </network>
                <network network="vk">
                  <i class="fa fa-fw fa-vk social-btn on-light" aria-hidden="true"></i>
                </network>
                <network network="linkedin">
                  <i class="fa fa-fw fa-linkedin social-btn on-light"></i>
                </network>
              </div>
            </social-sharing>
          </div>
        </header>

        <aside class="lg-col-2 md-col-3 sm-col-12 xs-col-12 mt4 pl3">
          <nav id="toc" class="sticky" v-if="articleHeaders.length > 1">
            <ul class="list-reset m0">
              <li class="mb2" v-for="(item, index) in articleHeaders" :key="index">
                <a
                  :href="item.href"
                  class="dark-grey"
                  :class="{'active': false}"
                  v-html="item.title"
                  @click="scrollTo($event, item.id)"
                ></a>
              </li>
            </ul>
          </nav>
        </aside>

        <div class="lg-col-7 md-col-9 sm-col-12 xs-col-12 mb4 default-links-nodeco">
          <section id="article-body" class="px3 my4 body" v-html="content.body"></section>
        </div>

        <aside class="lg-col-3 md-col-12 sm-col-12 xs-col-12 mt4 px3">
          <action-nav class="sticky"></action-nav>
        </aside>
      </article>
    </main>
    <footer-bar :lang="$route.params.lang"></footer-bar>
  </div>
</template>

<script>
export default {
  created () {
    this.init()
  },

  watch: {
    '$route' (to, from) {
      if (from.params.oid !== to.params.oid || from.params.slug !== to.params.slug || from.params.lang !== to.params.lang) {
        this.init()
      }
    }
  },

  data () {
    return {
      contentAPI: '',
      content: {},
      articleHeaders: [],
      meta: {},
      changeOrgAPI: 'https://api.change.org/v1/petitions/11887498?api_key=9d6e9d6859fff4e530136ed1b83c5ee941d73fd443aa3898b5bf283058de0fb0',
      corsProxy: 'https://cors-anywhere.herokuapp.com/',
      petitionData: {},
      windowLocation: String(window.location)
    }
  },

  methods: {
    init: function () {
      this.windowLocation = String(window.location)
      this.contentAPI = this.getContentAPIBase()
      let oid = this.$route.params.oid

      if (oid) {
        // load from a menu click
        let url = this.contentAPI + '/contents/' + oid
        fetch(url).then((response) => {
          return response.json()
        }).then((data) => {
          this.content = data
          if (data.lede && data.lede.length > 0) {
            this.content.lede = window.marked.parse(data.lede)
          }
          this.content.body = window.marked.parse(data.body)
        }).then(() => {
          this.articleHeaders = this.getArticleHeaders()
          this.updateMeta()
        }).catch((err) => {
          console.error('fetch error', err)
        })
      } else {
        // load from direct request
        let url = this.contentAPI + '/contents?language.code=' + this.$route.params.lang + '&slug=' + this.$route.params.slug
        fetch(url).then((response) => {
          // NOTE: there must be at least one result
          return response.json()
        }).then((data) => {
          this.content = data[0]
          if (this.content.lede && this.content.lede.length > 0) {
            this.content.lede = window.marked.parse(this.content.lede)
          }
          this.content.body = window.marked.parse(this.content.body)
        }).then(() => {
          this.articleHeaders = this.getArticleHeaders()
          this.updateMeta()
        }).catch((err) => {
          console.error('fetch error', err)
        })
      }
    },

    updateMeta: function () {
      document.title = this.content.title

      if (this.content.lede && this.content.lede.length > 0) {
        let descr = this.convertHTMLToText(this.content.lede)
        let m = document.querySelector('meta[name=description]')
        if (m) {
          m.content = descr
        } else {
          let m = document.createElement('meta')
          m.name = 'description'
          m.content = descr
          document.querySelector('head').appendChild(m)
        }
      }

      let oglist = [
        {name: 'og:title', content: this.content.title},
        {name: 'og:type', content: 'article'},
        {name: 'og:image', content: window.location.host + '/static/covers/public_opinion-3@2x.jpg'},
        {name: 'og:url', content: window.location}
      ]
      for (let og of oglist) {
        let m = document.createElement('meta')
        m.name = og.name
        m.content = og.content
        document.querySelector('head').appendChild(m)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/colors";

#toc {
  font-size: 0.8em;
}

.sticky {
  position: sticky;
  top: 2em;
}
</style>



// WEBPACK FOOTER //
// Page.vue?17a3ca57